module.exports = __webpack_public_path__ + "img/STAGE-2.jpg";